import React from "react"
import { Dialog } from "@ark-ui/react"

import { Icon } from "../Icon"

const ModalHeader = ({
  title,
  close,
}: {
  title?: string
  close?: () => void
}) => {
  if (!title && !close) return null

  return (
    <div className="cobalt-modal-header">
      <Dialog.Title className="cobalt-modal-header__title">
        {title}
      </Dialog.Title>
      {close && (
        <Dialog.CloseTrigger className="cobalt-modal-header__close-button">
          <span aria-hidden>
            <Icon source="close" color="subdued" />
          </span>
        </Dialog.CloseTrigger>
      )}
    </div>
  )
}

export default ModalHeader
